import { Grid, IconButton, TextField } from "@material-ui/core"
import { Delete } from "@material-ui/icons"
import AddBoxIcon from "@material-ui/icons/AddBox"

import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const MultipleEntry = (props) => {
  const { t } = useTranslation()
  const {
    value = "",
    name="",
    setMultipleValue,
    totalRows,
    displayRows,
    placeholder = "",
    regex="",
    onHandleHelperText=()=>{},
    formikError=false,
    customHandleChangeFunction=()=>{}
  } = props
  const [valueList, setValueList] = useState(value)

  useEffect(() => {
    setValueList(value)
  }, [value])

  const validateEmail = (input) => {
    if (input !== "") {
      return !regex.test(input)
    } else {
      return false
    }
  }
  const handleChange = (e, i) => {
    let tempValue = [...valueList]
    const targetValue = e.target.value
    let duplicateEmail = false
    tempValue.map((item) => {
      if (item.value === targetValue) {
        duplicateEmail = true
      }
    })
    const validEmail = validateEmail(targetValue)
    tempValue[i]["value"] = targetValue
    tempValue[i]["error"] = validEmail
    tempValue[i]["duplicate"] = duplicateEmail
    setValueList(tempValue)
    setMultipleValue(tempValue)
  }

  const removeEmail = (x, i) => {
    let tempValue = [...valueList]
    tempValue.splice(i, 1)
    setValueList(tempValue)
    setMultipleValue(tempValue)
  }

  const addNewEmail = (idx) => {
    let tempValue = [...valueList]
    if (tempValue.length < totalRows) {
      tempValue.push({ id: idx, value: "" })
      setValueList(tempValue)
      setMultipleValue(tempValue)
    }
  }
  const EmailPair = (x, i) => {
    let isError = x.error || x.duplicate || formikError
    return (
      <Grid container spacing={1}>
        <Grid
          item
          lg={9}
          style={{ marginBottom: "15px" }}
        >
          <TextField
            style={{
              width: "100%",
              backgroundColor:
                valueList.length !== i + 1 || valueList.length === totalRows+1
                  ? "#00000014"
                  : "unset",
            }}
            variant="outlined"
            size="small"
            type="text"
            name={`name${i}`}
            value={x.value}
            onChange={(e) => {
              handleChange(e, i)}
            }
            onMouseDown={(e) => {
              customHandleChangeFunction(e,i)
            }}
            error={isError}
            placeholder={placeholder || ""}
            helperText={
              onHandleHelperText(x,i)           
            }
            disabled={valueList.length !== i + 1 || valueList.length === totalRows+1}
          />
        </Grid>
        <Grid item style={{height:"40px",display:"flex"}}>
          {valueList.length !== i + 1 || valueList.length === totalRows ? (
            <IconButton
              style={{ padding: "0px" }}
              onClick={() => removeEmail(x, i)}
            >
              <Delete
                style={{ color: "var(--primaryColor)", fontSize: "30px" }}
              />
            </IconButton>
          ) : (
            <>
            <IconButton
              style={{ padding: "0px" }}
              disabled={(x.value === "" || isError)}
              onClick={() => addNewEmail(x.id + 1)}
            >
              <AddBoxIcon
                style={{
                  color:
                    x.value === "" || isError
                      ? "var(--greyColor)"
                      : "var(--primaryColor)",
                  fontSize: "30px",
                }}
                
              />
            </IconButton>
           {
              valueList?.length > 1 &&
              <IconButton
              style={{ padding: "0px" }}
              onClick={() => removeEmail(x, i)}
            >
              <Delete
                style={{ color: "var(--primaryColor)", fontSize: "30px" }}
              />
            </IconButton>}
            </>
          )}
        </Grid>
      </Grid>
    )
  }
  return (
      <Grid container style={{display:"block"}}>
        <Grid item xs={12}>
          {valueList
            .slice(0, totalRows / displayRows)
            ?.map((x, i) => EmailPair(x, i))}
        </Grid>
        <Grid item xs={12}>
          {valueList
            .slice(totalRows / displayRows, totalRows)
            ?.map((x, i) => EmailPair(x, i + totalRows / displayRows))}
        </Grid>
      </Grid>
    // </Grid>
  )
}
export { MultipleEntry }
export default MultipleEntry
